<template>
  <div class="table-tile" :title="item.item_name">
    <div class="table-tile__item">
      <div class="table-tile__item-block block-media">
        <img-product
        class="wrapp-image"
        :imgPath="item.image_url"
        :alt="item.item_name"
        :styleImage="{ maxWidth: '100%' }"
        />
      </div>
      <div class="table-tile__item-block block-name">
        <span class="label" v-html="item.item_name"></span>
      </div>
      <div class="table-tile__item-block block-motivation">
        <span class="label" v-html="item.resolution_name"></span>
      </div>
      <div class="table-tile__item-block block-request-type">
        <span class="label" v-html="item.condition_name"></span>
      </div>
      <div class="table-tile__item-block block-detail-motivation">
        <span class="label" v-html="item.reason_name"></span>
      </div>
      <div class="table-tile__item-block block-qty">
        <div class="label">{{ $t('Quantity') }}</div>
        <span class="value t-regular">{{ item.qty_requested }}</span>
      </div>
      <div class="table-tile__item-block block-subtotal block-latest">
        <span class="value f-bold">{{ item.item_order_price | price($store) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import ImgProduct from 'theme/components/Product/Image'

export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ImgProduct
  }
}
</script>
